module.exports = __webpack_public_path__ + "media/images/flags/1x1/cod-5290fa1f325cf2d1b897b46c2c3bb3ac.svg";